// extracted by mini-css-extract-plugin
export var suptitle = "styles-module--suptitle--187e4";